const reports = {
  apiClient: null,
  path: '/franchises/reports',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getMonthlyReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/monthly?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getBiweeklyReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/biweekly?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default reports;
